import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { useAuthenticationRequired } from "hooks";

const PrivateRoute = ({ component: Component, path, documentTitle, redirect, redirectPath, ...rest }) => {
	const { isAuthenticated } = useAuthenticationRequired();

	// Set a document title if one has been passed, otherwise default to the initial value
	const defaultTitle = useRef(document.title);
	useEffect( () => {
		document.title = documentTitle || defaultTitle.current;
	}, [ documentTitle ]);

	if(redirect) {
		return <Redirect to={redirectPath ? redirectPath : "/"} />;
	}

	const render = props => isAuthenticated === true
		? <Component {...props} />
		: null;

	return <Route path={path} render={render} {...rest} />;
};

PrivateRoute.propTypes = {
	component: PropTypes.elementType,
	path: PropTypes.string,
	documentTitle: PropTypes.string
};

export default PrivateRoute;
